export function applyBoardViewportTouchScrollDelta({
  viewport,
  deltaX,
  deltaY,
}: {
  viewport: HTMLDivElement;
  deltaX: number;
  deltaY: number;
}): boolean {
  let moved = false;
  if (deltaX !== 0) {
    viewport.scrollLeft += deltaX;
    moved = true;
  }
  if (deltaY !== 0) {
    window.scrollBy(0, deltaY);
    moved = true;
  }
  return moved;
}

export type BoardPinchZoomUpdate = {
  zoom: number;
  scrollLeft: number;
  windowScrollY: number;
};
